import userRound from '~/assets/icons/user_round.svg';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency, WalletType } from '~/shared';
import {
	StyledBalance,
	StyledContainer,
	StyledRightSide,
	StyledToggleSound,
	StyledUser,
} from './Head.styled';

const Head = () => {
	const donateIcon = useWalletIcon(Currency.Donate, true);
	const balance = useObservable(rage.bank.getBalance(WalletType.Donate));
	const realTime = useObservable(rage.game.getRealTime());
	const accountLogin = useObservable(rage.characterSelection.getAccountLogin());

	return (
		<StyledContainer>
			<StyledUser>
				<img src={userRound} />
				<Text>{accountLogin}</Text>
			</StyledUser>
			<Text style={{ color: '#FFFFFF', textAlign: 'center' }}>
				<span style={{ fontSize: 20, fontWeight: 700 }}>{realTime.time}</span>
				<br />
				<span style={{ fontSize: 16, fontWeight: 500, opacity: 0.5 }}>
					{realTime.weekday}
				</span>
			</Text>
			<StyledRightSide>
				<StyledBalance>
					<Text>{balance.toLocaleString('ru-RU')}</Text>
					<CurrencyIcon icon={donateIcon} size={16} />
				</StyledBalance>
				<StyledToggleSound data-character-select-control />
			</StyledRightSide>
		</StyledContainer>
	);
};

export { Head };
